export class ShowMoreEventTimesModalActions {
    confirm: () => void;
    cancel?: () => void;
}

export class ShowMoreEventTimesModalData {
    title: string;
    eventTimes: Date[];
    eventTimesText: Date[];
    timezone: string;
    isManualTime: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/show.more.event.times.modal/show.more.event.times.modal.provider.ts